import styled from "styled-components"

const List = styled.ul``

const Item = styled.li`
  &&& {
    &:not(:last-child) {
      margin-bottom: 5px;
    }

    > a {
      color: ${props => props.theme.colors.primary};
      text-decoration: underline;

      .no-touchevents &:hover {
        text-decoration: none;
      }
    }

    > ul {
      padding-left: 1em;
    }
  }
`

export const sToc = {
  List,
  Item,
}
